import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import PageHeader from "../Components/Pageheader";
import Sidebar from "../Components/Sidebar";
import { Link } from "react-router-dom";
import {
  detailone,
  detailthree,
  detailtwo,
  odetai2,
  odetai3,
  odetail,
} from "../Constant/Index";

function Myorderdetail() {
  return (
    <>
      <Header />
      <PageHeader pagename="my order detail" />
      {/* My order Detail Section  */}
      <section className="profile-sec ">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <Sidebar />
            </div>

            <div className="col-md-9">
              <div className="my-info-dv order-detail-sec">
                <div className="row">
                  <div className="col-md-6">
                    <div className="my-info-head">
                      <h3 className="primary-color">My Order Detail</h3>
                      <span className="primary-color">#0000654321</span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="edit-profile-dv">
                      <Link to="/review">
                        <button className="btn-all" style={{ width: "40%" }}>
                          Write A Review
                        </button>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="info-border order-info-border"></div>
                  </div>
                  <div className="col-md-4">
                    <div className="order-detail-dv">
                      <div className="order-detail-icon">
                        <img
                          src={odetai3}
                          className="img-fluid"
                          alt="order-img"
                        />
                      </div>
                      <div className="order-detail-para">
                        <h5 className="primary-color">Shipping Information</h5>
                        <p className="primary-color">
                          Lorem ipsum dolor sit ametc onsect eturad.
                        </p>
                        <p className="primary-color">Washington</p>
                        <p className="primary-color">78965</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 order-detail-border">
                    <div className="order-detail-dv">
                      <div className="order-detail-icon">
                        <img
                          src={odetai3}
                          className="img-fluid"
                          alt="order-img"
                        />
                      </div>
                      <div className="order-detail-para">
                        <h5 className="primary-color">Payment Info</h5>
                        <p className="primary-color"> 98** **** **** **53</p>
                        <p className="primary-color">9/32</p>
                        <p className="secondary-color">
                          <span>
                            <i
                              class="fa fa-check-circle"
                              aria-hidden="true"
                            ></i>
                          </span>
                          Paid
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="order-detail-dv">
                      <div className="order-detail-icon">
                        <img
                          src={odetai2}
                          className="img-fluid"
                          alt="order-img"
                        />
                      </div>
                      <div className="order-detail-para">
                        <h5 className="primary-color">Order Info</h5>
                        <p className="primary-color">
                          Shipping{" "}
                          <span className="font-weight-bold move-with">
                            United Kingdom
                          </span>
                        </p>
                        <p className="primary-color">
                          Payment{" "}
                          <span className="font-weight-bold move-with">
                            Paypal
                          </span>
                        </p>
                        <p className="primary-color">
                          Status{" "}
                          <span className="font-weight-bold move-with">
                            Approved
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-8">
                    <div className="radio-btn-dv">
                      <p>
                        <input
                          type="radio"
                          id="test1"
                          name="radio-group"
                          checked
                        />
                        <label for="test1">
                          <div className="radio-dv">
                            <img
                              src={detailone}
                              className="img-fluid"
                              alt="detail-one"
                            />
                            <p>Magnesium Bath Salt</p>
                            <p>#03</p>
                            <p>$ 49.00</p>
                          </div>
                        </label>
                      </p>
                      <p>
                        <input type="radio" id="test2" name="radio-group" />
                        <label for="test2">
                          {" "}
                          <div className="radio-dv">
                            <img
                              src={detailthree}
                              className="img-fluid"
                              alt="detail-one"
                            />
                            <p>Magnesium Bath Salt</p>
                            <p>#03</p>
                            <p>$ 49.00</p>
                          </div>
                        </label>
                      </p>

                      <p>
                        <input type="radio" id="test3" name="radio-group" />
                        <label for="test3">
                          {" "}
                          <div className="radio-dv">
                            <img
                              src={detailtwo}
                              className="img-fluid"
                              alt="detail-one"
                            />
                            <p>Magnesium Bath Salt</p>
                            <p>#03</p>
                            <p>$ 49.00</p>
                          </div>
                        </label>
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="order-payment-detail">
                      <div className="payment-dv">
                        <div className="payment-head">
                          <h3>Payment</h3>
                        </div>
                        <div className="total-price">
                          <p>Sub Total</p>
                          <p>$450</p>
                        </div>
                        <div className="total-price">
                          <p>Shipping Fee</p>
                          <p>$100</p>
                        </div>
                        <div className="total-price">
                          <p>United Kingdom</p>
                          <p>+$100</p>
                        </div>
                        <div className="total-price">
                          <p>Discount Code</p>
                          <p>-$150</p>
                        </div>

                        <div className="total">
                          <p>Total</p>
                          <p>$700.00</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ======================= */}

      <Footer />
    </>
  );
}

export default Myorderdetail;
